<template>
    <div>
        <!-- 系统列表 -->
        <a-table id="myServiceTable" :columns="columns" :data-source="tableData" :scroll="{ x: clientWidth}"
            :pagination="false" :loading="tloading" :rowKey="record => record.id ? record.id : Math.random()">
            
        </a-table>

        <a-pagination style="float:right;margin-top:20px;" v-model="pagination.page" :pageSize="pagination.pageSize"
            :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />
    </div>
</template>
<script>


const columns = [
    { 
        title: '应用编码',
        dataIndex: 'adcode',
        align:'center',
        width:120,
    },
    { 
        title: '城市编码', 
        dataIndex: 'citycode',
        align:'center',
        width:200, 
    },
    {
        title: '名称',
        dataIndex: 'name', 
        align:'center',
        width:200
    },
    {
        title: '类型',
        dataIndex: 'type', 
        align:'center',
        width:200
    },

];

export default {
    data() {
        return {
            columns,
            tableData:[],
            tloading:false,
            clientWidth:800,
            searchP:{},
            pagination:{
                total:0,
                pageSize:10,
                page:1,
            },
        };
    },
    methods: {
        handlePageChange(v){
            this.pagination.page = v
            this.getAppSumData();
        },
        getAppSumData(){
            let that = this
            let params = {
                ...that.searchP,
                ...that.pagination,
                urlparams:false
            };
            that.$store.dispatch({
                type: 'open/districtManage',
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    that.tableData = result.list;
                    that.pagination.total = parseInt(result.totalRecords);
                    that.pagination.pageSize = parseInt(result.pageSize);
                    that.pagination.page = parseInt(result.page);
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });
        },
        handleSearch(searchP){
            this.searchP = searchP;
            this.pagination.page = 1;
            this.getAppSumData();
        },
    },

    components:{
    },
    mounted(){
    }
};
</script>
<style scoped>
    .trend_pagination{
        margin-top: 10px;
    }

    .tableLink{
        margin-right: 10px;
    }

</style>

